module.exports = __webpack_public_path__ + "media/bootstrap-icons/grid-3x2-gap-fill-eb8ccc38.svg";